import * as React from 'react';

import { PageLayout } from 'shared/components/Page';

import { FaqSectionContainer } from '../FaqSection';
import { FeaturesSectionContainer } from '../FeaturesSection';
import { PartnersSectionContainer } from '../PartnersSection';
import { PricingSectionContainer } from '../PricingSection';
import { ProcessSectionContainer } from '../ProcessSection';
import { RealtorsSectionContainer } from '../RealtorsSection';
import { ReviewsSectionContainer } from '../ReviewsSection';
import { AgentModal, BannerForm } from '../forms';
import { StickyFooterContainer } from '../StickyFooter';

export const PageContainer: React.FC = () => {
  return (
    <>
      <PageLayout>
        <RealtorsSectionContainer />
        <FeaturesSectionContainer />
        <ProcessSectionContainer />
        <PricingSectionContainer />
        <PartnersSectionContainer />
        <BannerForm />
        <ReviewsSectionContainer />
        <FaqSectionContainer />
      </PageLayout>

      <AgentModal />
      <StickyFooterContainer />
    </>
  );
};
